var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-text",on:{"click":_vm.handleClick}},[_c('span',{class:[`status-text-${_vm.type}`, `status-text-size-${_vm.size}`]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }